// TOP LEVEL IMPORTS
import React from 'react';
// ANTD
import Input from 'antd/lib/input';
import Form from 'antd/lib/form';
// COMPONENTS
import SelectQuestionCategory from 'components/inputs/SelectQuestionCategory';

const FormItem = Form.Item;

class QuestionForm extends React.Component {
  render() {
    return (
      <div>
        <div>
          <label>Question</label>
          <Input
            size="large"
            style={{ marginBottom: 5 }}
            defaultValue={this.props.title}
            onChange={e => this.props.onChange({ title: e.target.value })}
          />
        </div>
        <div>
          <label>Category</label>
          <SelectQuestionCategory onChange={this.props.onChange} />,
        </div>
      </div>
    );
  }
}

QuestionForm.propTypes = {};

export default QuestionForm;



// WEBPACK FOOTER //
// ./src/components/forms/QuestionForm/index.js